/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-11 12:44:26
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-05-09 13:21:04
 * @FilePath: /zeelool-nextjs/src/components/Tabs/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import {
  Box,
  BoxProps,
  Tab as MuiTab,
  Tabs as MuiTabs,
  TabsProps as MuiTabsProps,
  SxProps,
} from '@mui/material';
import React, { ReactNode, useState } from 'react';

// 定义自定义Tab项的接口
export interface TabItemProps {
  key: string;
  label: ReactNode;
  disabled?: boolean;
  children?: ReactNode;
}

// 定义自定义Tabs组件的Props
export interface TabsProps {
  items: TabItemProps[];
  activeKey?: string;
  defaultActiveKey?: string;
  onChange?: (key: string) => void;
  centered?: boolean;
  tabBarExtraContent?: ReactNode;
  type?: 'line' | 'button';
  scrollable?: boolean;
  scrollButtons?: boolean | 'auto';
  showLine?: boolean;
  sx?: SxProps;
  hasTabContent?: boolean; // 是否显示Tab内容
  tabBarExtraContentClassName?: string; // 额外内容类名
  muiTabsProps?: MuiTabsProps;
  tabsWrapperProps?: BoxProps;
}

/**
 * 自定义Tabs组件
 */
const Tabs = ({
  items,
  activeKey,
  defaultActiveKey,
  onChange,
  centered = false,
  tabBarExtraContent,
  type = 'line',
  scrollable = false,
  scrollButtons = false,
  showLine = true,
  sx,
  hasTabContent = true,
  tabBarExtraContentClassName = '',
  muiTabsProps = {},
  tabsWrapperProps = {},
}: TabsProps) => {
  // 如果提供了activeKey，则使用受控模式；否则使用非受控模式
  const [activeTab, setActiveTab] = useState(activeKey || defaultActiveKey || items[0]?.key);

  // 当选项卡变更时的处理函数
  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    if (!activeKey) {
      setActiveTab(newValue);
    }
    onChange?.(newValue);
  };

  // 渲染Tab项
  const renderTabItems = () => {
    return items.map((item) => (
      <MuiTab
        sx={{
          overflow: 'unset',
        }}
        key={item.key}
        label={item.label}
        value={item.key}
        disabled={item.disabled}
      />
    ));
  };

  // 渲染当前活动Tab的内容
  const renderTabContent = () => {
    const currentTab = items.find((item) => item.key === (activeKey || activeTab));
    return currentTab?.children;
  };
  // 根据滚动和居中属性确定Tab变体
  let tabVariant = 'standard';
  if (scrollable) {
    tabVariant = 'scrollable';
  } else if (centered) {
    tabVariant = 'fullWidth';
  }

  return (
    <Box className="tabs-container">
      <Box
        {...tabsWrapperProps}
        sx={{
          display: 'flex',
          alignItems: 'center',
          borderBottom: type === 'line' && showLine ? 1 : 0,
          borderColor: 'divider',
          '& .MuiButtonBase-root.MuiTab-root': {
            paddingLeft: '0',
            paddingRight: '0',
          },
          ...tabsWrapperProps.sx,
        }}
      >
        <MuiTabs
          value={activeKey || activeTab}
          onChange={handleChange}
          variant={tabVariant as 'scrollable' | 'fullWidth' | 'standard'}
          centered={centered}
          scrollButtons={scrollButtons}
          TabIndicatorProps={{
            style: {
              display: type === 'button' ? 'none' : 'block',
            },
          }}
          // 未选中的色值是red

          sx={{
            '& .MuiTab-root': {
              color: '#808080',
            },
            '& .MuiTab-root.Mui-selected': {
              color: '#282828',
            },
            ...sx,
          }}
          {...muiTabsProps}
        >
          {renderTabItems()}
        </MuiTabs>
        {tabBarExtraContent && (
          <Box className={tabBarExtraContentClassName}>{tabBarExtraContent}</Box>
        )}
      </Box>
      {hasTabContent && <Box sx={{ p: 1 }}>{renderTabContent()}</Box>}
    </Box>
  );
};

export default Tabs;
